import {getSite,getSystem} from './site'
import {getPlatform} from './page'
import $ from 'jquery'

const sld={
	base:{
		translate: '//translate.jd.com'
	}
}
sld.eptbase={
	...sld.base,
	rest: '//jshop-rest.joybuy.com',
	cookieBase: '.eptjshop.jd.com',
	promo:`//ipromo.joybuy.com`,
	appProto:`openapp.ept.jdmobile://virtual`,
	yuding:'//yuding.jd.com'
}
sld.XTL={
	...sld.base,
	rest: '//ejshop-rest.jd.com',
	cookieBase: '.ejshop.jd.com',
	promo:`//ipromo.jd.com`,
	yuding:'//yuding.jd.com',
	mall:'//emall.jd.com/zgb',
	mshop:'//emall.jd.com/zgb',
	sale:'//esale.jd.com/zgb',
	index:{
		pc:'//www.jd.com',
		mob:'//m.jd.com'
	},
	appProto:`openApp.jdb2bMobile://virtual`,
	signin:'//plogin.m.jd.com',
	zgbapi:'//zgbgw.m.jd.com',
	zgb:'//zgb.m.jd.com'
}
sld.TH={
	...sld.base,
	rest: '//jshop-rest.jd.co.th',
	price: '//p.jd.co.th',
	cart: '//cart.jd.co.th',
	cookieBase: '.jd.co.th',
	mall:'//mall.jd.co.th',
	sale:'//sale.jd.co.th',
	mshop:'//shop-m.jd.co.th',
	index:{
		pc:'//www.jd.co.th',
		mob:'//m.jd.co.th'
	},
	item:'//item.jd.co.th',
	mItem:'//mitem.jd.co.th',
	appProto:`openjdthai://virtual`,
	signin:'//passport.jd.co.th',
	yuding:'//yuding.jd.co.th'
}
sld.US={
	...sld.eptbase,
	rest: '//jshop-rest.joybuy.com',
	mall:'//mall.joybuy.com',
	mshop:'//mall.joybuy.com',
	sale:'//sale.joybuy.com',
	index:{
		pc:'//www.joybuy.com',
		mob:'//m.joybuy.com'
	},
	signin:'//passport.joybuy.com',
	msignin:'//msignin.joybuy.com',
}
sld.RU={
	...sld.eptbase,
	rest: '//jshop-rest.jd.ru',
	mall:'//mall.jd.ru',
	mshop:'//mall.jd.ru',
	sale:'//sale.jd.ru',
	index:{
		pc:'//www.jd.ru',
		mob:'//m.jd.ru'
	},
	signin:'//passport.jd.ru',
	msignin:'//msignin.jd.ru',
}
sld.ES={
	...sld.eptbase,
	rest: '//jshop-rest.joybuy.es',
	mall:'//mall.joybuy.es',
	mshop:'//mall.joybuy.es',
	sale:'//sale.joybuy.es',
	index:{
		pc:'//www.joybuy.es',
		mob:'//m.joybuy.es'
	},
	signin:'//passport.joybuy.es',
	msignin:'//msignin.joybuy.es',
}
sld.ID={
	rest: '//jshop-rest.jd.id',
	cookieBase: '.jd.id',
	index:{
		pc:'//www.jd.id',
		mob:'//m.jd.id'
	},
}

export const SLD =()=> {
	return sld[getSite()]
}

export const INTERFACE = ({platform,effect}={}) => {
	if(!platform){
		platform=getPlatform().platform
	}
	if(!effect){
		effect=getPlatform().effect
	}
	const sld=SLD()
	let sys=getSystem()
	let api={
		previewUrl:`/${effect}/${platform}/preview.html`,
		editorUrl:`/${effect}/${platform}/editor.html`,
		template: {
			module: '/pub/page/getModuleTemplate',
			layout: `/${effect}/${platform}/page/getLayoutTemplate`,
		},
		appIndex: `/shop/${platform}/page/appIndex`,
		updateApp: `/${effect}/${platform}/page/updateApp`,
		getPage: `/${effect}/${platform}/page/getPage`,
		module: {
			add: `/${effect}/${platform}/page/addModule`,
			save: `/${effect}/${platform}/page/saveModule`,
			remove: `/${effect}/${platform}/page/removeModule`,
			list: `/${effect}/${platform}/page/getModuleList`,
			move: `/${effect}/${platform}/page/moveModule`,
			changeTemplate: `/${effect}/${platform}/template/useTemplate`,
			copy:`/${effect}/${platform}/page/copyModule`,
			exist:`/${effect}/${platform}/page/existCopyModule`,
		},
		layout: {
			add: `/${effect}/${platform}/page/addLayout`,
			config: `/${effect}/${platform}/page/configLayout`,
			save: `/${effect}/${platform}/page/saveLayoutParam`,
			remove: `/${effect}/${platform}/page/removeLayout`,
			list: `/${effect}/${platform}/page/getLayoutList`,
			move: `/${effect}/${platform}/page/moveLayout`
		},
		version: {
			schedule: `/${effect}/${platform}/version/versionSchedule`,
			cancelSchedule: `/${effect}/${platform}/version/cancelSchedule`,
			online: `/${effect}/${platform}/version/immediateOnline`,
			update: `/${effect}/${platform}/version/update`,
			create: `/${effect}/${platform}/version/create`,
			find: `/${effect}/${platform}/version/selectByPage`,
			del: `/${effect}/${platform}/version/deleteByIds`,
			pages: `/${effect}/${platform}/version/getPageList`,
		},
		backup: {
			create: `/${effect}/${platform}/page/createBackup`,
			createVersion: `/shop/${platform}/version/backupAppVersion`,
			list: `/${effect}/${platform}/page/getBackupList`,
			del: `/${effect}/${platform}/page/delBackup`,
			restore: `/${effect}/${platform}/page/restorePage`,
			getPage: `/${effect}/${platform}/page/getBackupPage`
		},
		act: {
			enable: `/act/${platform}/app/enableApplication`,
			disable: `/act/${platform}/app/disableApplication`,
			del: `/act/${platform}/app/delApplication`,
			add: `/act/${platform}/app/addApplication`,
			update: `/act/${platform}/app/updateApplication`,
			list: `/act/${platform}/app/getApplicationList`,
			manage: `/act/${platform}/app/manage`,
			bindMob: `/act/${platform}/app/bindMobAppRedirectUrl`,
			bindRedirect: `/act/${platform}/app/bindRedirectUrl`,
			child: {
				add: `/act/${platform}/app/addChildPage`,
				list: `/act/${platform}/app/getChildPageList`,
				edit: `/act/${platform}/app/editChildPage`,
				del: `/act/${platform}/app/delChildPage`,
			},
			getShareToMe:`/act/${platform}/app/getsharetomeapp`,
			getSharing:`/act/${platform}/app/getsharinguser`,
			setSharing:`/act/${platform}/app/setSharePinSet`,
		},
		pageTemplate: {
			list: `/act/${platform}/page/getPageTemplate`,
			listIShare: `/act/${platform}/page/getTemplateSharedByMe`,
			listShareI: `/act/${platform}/page/getSharedTemplateToMe`,
			listICommon:`/act/${platform}/page/getPubPageLibByMe`,
			listCommon:`/act/${platform}/page/getPubPageLibByPage`,
			del: `/act/${platform}/page/delPageTemplateInBatches`,
			share: `/act/${platform}/page/sharePageTemplate`,
			validateUser: `/act/${platform}/page/validateUser`,
			userInfo: `/act/${platform}/page/checkShareInfo`,
			shareInfo: `/act/${platform}/page/getShareInfo`,
			commonInfo:`/act/${platform}/page/checkSubmitInfo`,
			audit:`/act/${platform}/page/submitPageTemplate`,
			cancelAudit:`/act/${platform}/page/undoSubmit`,
			tags:`/act/${platform}/template/list`,
		},
		moduleTemplate: {
			list: `/${effect}/${platform}/template/getTemplateProfile`,
			create: `/${effect}/${platform}/template/createTemplate`,
			edit: `/${effect}/${platform}/template/updateTemplate`,
			del: `/${effect}/${platform}/template/delTemplate`,
			share:`/${platform}/template/share/private`,
			listIShare:`/${platform}/template/share/list`,
			listShareI:`/${platform}/template/share/list/toMe`,
			listCommon:`/${platform}/template/share/list/all`,
			listIShareCommon:`/${platform}/template/share/list/public`,
			shareInfo:`/${platform}/template/share/private/list`,
			shareCommon:`/${platform}/template/share/public/commit`,
			revokeCommon:`/${platform}/template/share/public/revoke`,
			userInfo:id=>`/${platform}/template/share/private/${id}`,
			count:`/${platform}/template/share/count`,
			site:`/${effect}/${platform}/template/site`
		},
		shopTemplate:{
			list:`/pub/sysShopTemplate/getAllShopSysTemplate`,
			apply:`/pub/sysShopTemplate/useShopSysTemplate`,
			reset:`/pub/sysShopTemplate/unUseSysTemplate`,
			getPage:`/pub/sysShopTemplate/getSysTemplatePage`
		},
		switchHead: `/${effect}/${platform}/page/updateShopUseHead`,
		editChildPage: `/${effect}/${platform}/app/editChildPage`,
		publishVersion: `/${effect}/${platform}/page/publishShopVersion`,
		publishAct: `/${effect}/${platform}/page/publish`,
		savePageParam: `/${effect}/${platform}/page/savePageParam`,
		register: '/sys/doRegister',
		goods: '/pub/page/getGoodInfoBySkuIds', //商品搜索模块接口
		promotion:'/pub/page/getPromoInfoByIds', //促销模块接口
		promotionState:`${sld.rest}/spikeGoods/batchQueryInfo`, //促销模块状态实时接口
		coupon: `/pub/page/getShopCouponList`, //店内搜索结果模块接口
		batchCoupon:`${sld.rest}/coupon/getCouponInfoByBatchIds`,
		getShopClassifyList: '/pub/page/getShopCategory', //获取店铺店内分类
		getVenderInfo: '/pub/page/getVenderInfo', //获取店铺信息
		shopSearch:`${sld.rest}/shop/product/new/search`,
		getCouponInfo:'/pub/page/getCouponInfo',
		collectCoupon:`${sld.rest}/coupon/getActiveCoupon`,
		isCollectedCoupon:`${sld.rest}/coupon/getCouponStatus`,
		appInfo: `/act/${platform}/page/getAppInfo`, //获取活动短码
		price: `${sld.price}/prices/mgets`, //实时价接口
		isSaleOut:`${sld.rest}/getProductStockBySkuIds`,
		shopGoods: `${sld.rest}/shop/product/search.action`, //店内搜索结果模块接口
		presale:`${sld.yuding}/presaleInfo/getPresaleInfoBySkus`, //预售接口
		category:`${sld.rest}/category`,
		addCart: `${sld.cart}/api/cart/addCartFromDetail`, //加入购物车接口
		translate: `${sld.translate}/translate/jshop.jd.co.th/1000127`,
		skuInfo : `${sld.rest}/th/getSkuBaseInfo`,
		now:`${sld.rest}/system/time`,
		mall: {
			list: {
				pc: (venderId, id='') => `${sld.mall}/pc/list-${venderId}.html${id?`?shopCategoryId=${id}`:''}`,
				mob: (venderId, id='') => `${sld.mall}/m/list-${venderId}.html${id?`?shopCategoryId=${id}`:''}`,
			},
			detail: {
				pc: (venderId) => `${sld.mall}/pc/index-${venderId}.html`,
				mob: (venderId) => `${sld.mall}/m/index-${venderId}.html`,
			},
			search: {
				pc: (venderId) => `${sld.mall}/pc/search-${venderId}.html`,
			},
			index: {
				pc: (venderId) => `${sld.mall}/pc/index-${venderId}.html`,
				mob: (venderId) => `${sld.mall}/m/index-${venderId}.html`,
			},
		},
		jd:{
			search:{
				pc:`${sld.index.pc}/search`,
				mob:`${sld.index.mob}/search/result/list`
			},
			list:{
				pc:(id,word)=>`${sld.index.pc}/category/${id}-${word}.html`
			}
		},
		item: {
			pc: sku => `${sld.item}/${sku}.html`,
			mob: sku => `${sld.mItem}/${sku}.html`
		},
		sale: {
			pc: (str) => `${sld.sale}/pc/${str}.html`,
			mob: (str) => `${sld.sale}/m/${str}.html`,
		}
	}
	const shopName=$("#J_venderNameAndVenderId").val()
	if(sys=='th'){
		api={
			...api,
			item:{
				pc:sku=>`${sld.item}/${sku}.html`,
				mob:sku=>`${sld.mItem}/product/${sku}.html?itemSource=INTL-A-02`,
				app:sku=>`${sld.appProto}?params={"category":"jump","des":"productDetail","sourceValue":"JSHOP_SOURCE_VALUE","sourceType":"JSHOP_SOURCE_TYPE","skuId":"${sku}","landPageId":"jshop.cx.mobile","refurl":"${window.location.href}"}`
			},
			login:{
				pc:`${sld.signin}/user/facade?ReturnUrl=${location.href}`,
			},
			shopCate:`//seller-s.jd.co.th/shopCategory/getList`,
			image:end=>`//img.jd.co.th/n7/${end}`,
			imagen1:end=>`//img.jd.co.th/n1/${end}`,
			mall: {
				list: {
					pc: (venderId, id='') => `${sld.index.pc}/shop/pc/${shopName||venderId}/list.html${id?`?shopCategoryId=${id}`:''}`,
					mob: (venderId, id='') => `${sld.mshop}/m/search/search?venderId=${venderId}&cateId=${id}`
				},
				detail: {
					pc: (venderId) => `${sld.index.pc}/shop/pc/${shopName||venderId}.html`,
					mob: (venderId) => `${sld.mshop}/detail/detailInfo?venderId=${venderId}`
				},
				search: {
					pc: (venderId) => `${sld.index.pc}/shop/pc/${shopName||venderId}/search.html`,
				},
				index: {
					pc: (venderId) => `${sld.index.pc}/shop/pc/${shopName||venderId}.html`,
					mob: (venderId) => `${sld.mshop}/?venderId=${venderId}`
				},
			},
			sale: {
				pc: (str) => `${sld.index.pc}/sale/pc/${str}.html`,
				mob: (str) => `${sld.sale}/m/${str}.html`,
			}
		}
	}
	if(sys=='ept'){
		api={
			...api,
			item:{
				pc:id=>`${sld.index.pc}/${id}.html`,
				mob:id=>`${sld.index.mob}/${id}.html`,
				app:id=>`${sld.appProto}?params=${encodeURIComponent(`{"des":"detail","params":{"skuId":${id}}}`)}`,
				app2:(sku,spu)=>`${sld.appProto}?params=${encodeURIComponent(`{"des":"detail","params":{"skuId":${sku},"productId":${spu}}}`)}`
			},
			index:{
				...sld.index,
				app:`${sld.appProto}?params=${encodeURIComponent(`{"des":"home"}`)}`
			},
			spuItem:{
				pc:id=>`${sld.index.pc}/product/${id}.html`,
				mob:id=>`${sld.index.mob}/product/${id}.html`,
				app:id=>`${sld.appProto}?params=${encodeURIComponent(`{"des":"detail","params":{"productId":${id}}}`)}`
			},
			shopCate:`//seller.jd.com/index.do`,
			image:end=>`//img14.joybuy.com/n7/${end}`,
			image0:end=>`//img14.joybuy.com/eptjshop/${end}`,
			imagen1:end=>`//img14.joybuy.com/n1/${end}`,
			login:{
				pc:`${sld.signin}/new/facade.html?ReturnUrl=${location.href}`,
				mob:`${sld.msignin}/m/new/facade.html?ReturnUrl=${location.href}`,
				app:`${sld.appProto}?params={"des":"login"}`
			},
			loginJump:{
				erp:`${sld.rest}/ept/jdLogin`,
				passport:`${sld.rest}/ept/erpLogin`
			},
			spuPrice:`${sld.promo}/api/promoinfo/getSpuPrices.html`,
			skuPrice:`${sld.promo}/api/promoinfo/getPriceInfos.html`,
			promotionState:`${sld.promo}/api/promoinfo/getPromoStateAndPrices.html`,
			mall: {
				list: {
					pc: (venderId, id='') => `${sld.index.pc}/shop/pc/${shopName||venderId}/list.html${id?`?shopCategoryId=${id}`:''}`,
					mob: (venderId, id='') => `${sld.mall}/m/list-${venderId}.html${id?`?shopCategoryId=${id}`:''}`,
				},
				detail: {
					pc: (venderId) => `${sld.index.pc}/shop/pc/${shopName||venderId}.html`,
					mob: (venderId) => `${sld.mall}/m/index-${venderId}.html`,
				},
				search: {
					pc: (venderId) => `${sld.index.pc}/shop/pc/${shopName||venderId}/search.html`,
				},
				index: {
					pc: (venderId) => `${sld.index.pc}/shop/pc/${shopName||venderId}.html`,
					mob: (venderId) => `${sld.mall}/m/index-${venderId}.html`,
				},
			},
			sale: {
				pc: (str) => `${sld.index.pc}/sale/pc/${str}.html`,
				mob: (str) => `${sld.sale}/m/${str}.html`,
			}
		}
		api.mall.list.app=(venderId, id) => `${sld.appProto}?params=${encodeURIComponent(`{"des":"search","params":{"showSearchBar":true,"categoryId":"${id}"}}`)}`
	}
	if(sys=='EJSHOP'){
		api={
			...api,
			item:{
				pc:id=>`${sld.zgb}/detail.html?id=${id}`,
				mob:id=>`${sld.zgb}/detail.html?id=${id}`,
				app:id=>`${sld.appProto}?params=${encodeURIComponent(JSON.stringify({"category":"jump","des":"productdetail","skuId":id}))}`
			},
			sale: {
				pc: (str) => `${sld.sale}/pc/${str}.html`,
				mob: (str) => `${sld.sale}/m/${str}.html`,
				app:(str) =>`${sld.appProto}?params=${encodeURIComponent(`{"des":"activity","url":"${str}"}`)}`
			},
			index:{
				...sld.index,
				app:`${sld.appProto}?params=${encodeURIComponent(`{"des":"home"}`)}`
			},
			spuItem:{
				pc:id=>`${sld.index.pc}/product/${id}.html`,
				mob:id=>`${sld.index.mob}/product/${id}.html`,
				app:id=>`${sld.appProto}?params=${encodeURIComponent(`{"des":"detail","params":{"productId":${id}}}`)}`
			},
			toast:str=>`${sld.appProto}?params={"des":"toast","body":"${str}"}`,
			shopCate:`//seller.jd.com/index.do`,
			image:end=>`//img14.joybuy.com/n7/${end}`,
			imagen1:end=>`//img14.joybuy.com/n1/${end}`,
			addCart:`${sld.zgbapi}/one.cart`,
			weixin:`${sld.zgbapi}/one.weixin`,
			login:{
				pc:`${sld.signin}/new/facade.html?ReturnUrl=${location.href}`,
				mob:`${sld.signin}/user/login.action?appid=100&returnurl=${location.href}`,
				app:`${sld.appProto}?params={"des":"login","url":"","reload":true}`,
			},
			loginJump:{
				erp:`${sld.rest}/ept/jdLogin`,
				passport:`${sld.rest}/ept/erpLogin`
			},
			spuPrice:`${sld.promo}/api/promoinfo/getSpuPrices.html`,
			skuPrice:`${sld.promo}/api/promoinfo/getPriceInfos.html`,
			favor:{
				exist:`${sld.rest}/ept/existInFavorite`,
				remove:`${sld.rest}/ept/removeFavorite`,
				add:`${sld.rest}/ept/favoriteShop`
			},
			goods:`${sld.zgbapi}/one.querySkuIds`,
			goodsForJshop:`${sld.zgbapi}/one.queryJshopSkuIds`,
			fetchCoupon:`${sld.zgbapi}/one.fetchCoupon`,
			getCouponInfo:`/pub/page/getXtlCouponInfo`,
		}
		api.mall.list.app=(venderId, id) => `${sld.appProto}?params=${encodeURIComponent(`{"des":"search","params":{"showSearchBar":true,"categoryId":"${id}"}}`)}`
	}
	return api
}